export default "__VITE_ASSET__3KGHEnCY__"